// Settings component for configuring game options
import { useState } from 'react';
import './Settings.css';

export interface GameSettings {
  enableMemories: boolean;
  enableAsciiArt: boolean;
  enableDebugMode: boolean;
}

interface SettingsProps {
  settings: GameSettings;
  onSave: (settings: GameSettings) => void;
  onClose: () => void;
}

export function Settings({ settings, onSave, onClose }: SettingsProps) {
  const [enableMemories, setEnableMemories] = useState(settings.enableMemories);
  const [enableAsciiArt, setEnableAsciiArt] = useState(settings.enableAsciiArt);
  const [enableDebugMode, setEnableDebugMode] = useState(settings.enableDebugMode);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      enableMemories,
      enableAsciiArt,
      enableDebugMode
    });
  };

  return (
    <div className="settings-overlay">
      <div className="settings-modal">
        <div className="settings-header">
          <h2>Settings</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit} className="settings-form">
          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={enableMemories}
                onChange={(e) => setEnableMemories(e.target.checked)}
              />
              Enable Memory System
              <span className="hint">Store and recall story context</span>
            </label>
          </div>

          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={enableAsciiArt}
                onChange={(e) => setEnableAsciiArt(e.target.checked)}
              />
              Enable ASCII Art
              <span className="hint">Generate ASCII art for dramatic scenes</span>
            </label>
          </div>

          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={enableDebugMode}
                onChange={(e) => setEnableDebugMode(e.target.checked)}
              />
              Enable Debug Mode
              <span className="hint">Show raw AI prompts and responses</span>
            </label>
          </div>

          <div className="settings-actions">
            <button type="button" className="btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save Settings
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export const DEFAULT_SETTINGS: GameSettings = {
  enableMemories: true,
  enableAsciiArt: false,
  enableDebugMode: false
};
